import { render, staticRenderFns } from "./about-slider.vue?vue&type=template&id=ff821b84&scoped=true"
import script from "./about-slider.vue?vue&type=script&lang=js"
export * from "./about-slider.vue?vue&type=script&lang=js"
import style0 from "./about-slider.vue?vue&type=style&index=0&id=ff821b84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff821b84",
  null
  
)

export default component.exports